import * as types from "./ActionTypes";

export function write(title, content) {
  return {
    type: types.WRITE,
    title: title,
    content: content
  };
}

export function clear() {
  return {
    type: types.CLEAR
  };
}
